import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function CTAButton({
  text,
  className = '',
  href
}: {
  text: string;
  className?: string;
  href?: string;
}) {
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`relative group overflow-hidden rounded-lg bg-cyan-500 text-[#0a0e1a] font-bold text-lg md:text-xl px-8 py-4 flex items-center justify-center gap-3 transition-all duration-300 hover:bg-cyan-400 hover:shadow-[0_0_30px_rgba(0,212,255,0.6)] ${className}`} onClick={() => {
    if (href) {
      trackAddToCart();
      window.open(href, '_blank');
    } else {
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }} data-id="element-24">
      <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-25"></span>
      <Zap className="w-6 h-6" data-id="element-26" />
      <span className="font-rajdhani tracking-wide" data-id="element-27">{text}</span>
    </motion.button>;
}